/* eslint-disable import/no-anonymous-default-export */
import './index.scss';
import Group from './Group';
import Field from './Field';
import Result from './Result';
export default {
    Group,
    Field,
    Result
}